module.exports = __webpack_public_path__ + "static/6305-woodrose-24-be610cd22692a401920de9c1697f9e50.jpg";